import { useStore } from '../../../../hooks/storeHook'

export const useCategoriesDiff = () => {
  const {
    productStore: {selectedProductCard, marketplaceProductCard},
    homeNavRequired
  } = useStore()

  const integrationType = homeNavRequired.integrationType

  switch (integrationType) {
    case 1 : {
      if (selectedProductCard?.ozonCategory?.name !== marketplaceProductCard?.ozonCategory?.name) {
        return marketplaceProductCard?.ozonCategory?.name
      } else {
        return null
      }
    }
    case 2 : {
      if (selectedProductCard?.wbCategory?.name !== marketplaceProductCard?.wbCategory?.name) {
        return marketplaceProductCard?.wbCategory?.name
      } else {
        return null
      }
    }
    case 4 : {
      if (selectedProductCard?.yandexMarketCategory?.name !== marketplaceProductCard?.yandexMarketCategory?.name) {
        return marketplaceProductCard?.yandexMarketCategory?.name
      } else {
        return null
      }
    }
    default: {
      return null
    }
  }
}